<template>
  <component
    :is="tooltipDescription ? BaseTooltip : 'div'"
    :description="tooltipDescription"
    :class="{ contents: !tooltipDescription }"
  >
    <ContextMenu
      :items="freqItems"
      color="primary"
      outline
      :disabled="disabled || !meteringPoint"
      :small
      :loading
      class="w-full md:w-auto"
      @update:model-value="onContextMenuOpened"
    >
      <BaseIcon name="download-2" filled class="mr-1" />
      Export
    </ContextMenu>
  </component>
</template>

<script setup>
import { ref, computed } from "vue"
import { triggerEvent } from "@/services/plausibleService.js"
import useNotificationStore from "@/stores/notificationStore.js"
import {
  EXPORT_TYPES,
  default as useExportsStore,
} from "@/stores/repower/exportsStore.js"
import { useRouter } from "vue-router"
import {
  BaseIcon,
  BaseTooltip,
  ContextMenu,
} from "@repowerednl/ui-component-library"

const props = defineProps({
  meteringPoint: {
    type: Object,
    default: null,
  },
  dateRange: {
    type: Array,
    required: true,
  },
  type: {
    type: String,
    default: null,
    validator: (value) => Object.values(EXPORT_TYPES).includes(value),
  },
  tooltipDescription: {
    type: [String, Boolean],
    default: "",
  },
  disabled: Boolean,
  small: Boolean,
})

const emit = defineEmits(["opened", "closed"])

const notificationStore = useNotificationStore()
const exportsStore = useExportsStore()
const router = useRouter()
const loading = ref(false)

const freqItems = computed(() => {
  const items = [
    {
      label: "Per dag",
      action: () => requestExport("1D"),
    },
    {
      label: "Per uur",
      action: () => requestExport("1h"),
    },
    {
      label: "Per kwartier",
      action: () => requestExport("15min"),
    },
  ]

  if (props.type === EXPORT_TYPES.MEASUREMENTS) {
    items.push({
      label: "Per minuut",
      action: () => requestExport("1min"),
    })
  }

  return items
})

function onContextMenuOpened(isOpen) {
  if (isOpen) {
    emit("opened")
  } else {
    emit("closed")
  }
}

function onRequested() {
  notificationStore.pushContentToast({
    title: "Export aangevraagd",
    message:
      "We zetten je export zo snel mogelijk klaar. Volg de status via Documenten > Exports.",
    action: () => router.push({ name: "documents-exports" }),
    actionLabel: "Bekijk exports",
  })
  loading.value = false
}

function onRequestFailed(error) {
  notificationStore.pushError(
    "Fout bij het aanvragen van export",
    `De gegevensexport kon niet worden aangevraagd. Probeer het later opnieuw. (code: ${error.code})`,
    "download-export-error",
  )
  loading.value = false
}

function requestExport(freq) {
  loading.value = true
  let measurementTypes = null
  if (props.type === EXPORT_TYPES.MEASUREMENTS) {
    measurementTypes =
      props.meteringPoint.type === "Battery" ? ["power", "soc"] : ["power"]
  }
  exportsStore.requestExport(
    props.meteringPoint.id,
    props.type,
    props.dateRange,
    freq,
    measurementTypes,
    onRequested,
    onRequestFailed,
  )
  triggerEvent(`export:request-${props.type}`)
}
</script>
